module.exports = __webpack_public_path__ + "img/26.a1db90f4.jpg";